import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';
import { applicationPaths, localStorageKeys } from '../../../Models/configurations';
import { CheckInDataService } from '../../../Services/check-in-data.service';
import { SecureStorageService } from './../../../Services/secure-storage.service';
import { UtilityServices } from './../../../Services/utility.services';
import { LpAuthenticationComponent } from './lp-authentication/lp-authentication.component';
import { TranslateService } from '@ngx-translate/core';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit, AfterViewInit {
  urlName: string;
  public logoLink: string;
  isValidLpAuth = false;
  validLp: string;
  isCheckInApiCalled = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly router: Router,
    private readonly checkInDataService: CheckInDataService,
    private readonly utilityService: UtilityServices,
    private readonly secureStorageService: SecureStorageService,
    private readonly spinner: NgxSpinnerService,
    private readonly modalService: NgbModal,
    private readonly translate: TranslateService,
    private readonly globalSetting: GlobalSetting,
    public toaster: ToastrService,
    private readonly currentLanguageService: CurrentLanguage
  ) {
    this.urlName = '/' + applicationPaths.login;
  }

  private removOlderData() {
    this.secureStorageService.removeStringKeyArray([
      localStorageKeys.ownerDetails,
      localStorageKeys.privacyConsent,
      localStorageKeys.additionalDetails,
      localStorageKeys.serviceDetails,
      localStorageKeys.offerValueDetails]);
  }

  ngAfterViewInit(): void {
    this.isCheckInApiCalled.subscribe(checkInApi => {
      if(checkInApi){
        this.checkInDataService.GetCdkRepairData().subscribe(apiRes => {
            this.secureStorageService.setKeyData(localStorageKeys.cdkRepairData, apiRes);
            this.checkInDataService.cdkRepairDetails.next(true);
        },
        _error => {
          this.checkInDataService.cdkRepairDetails.next(true);
        });
      }
    })

  }

  ngOnInit(): void {
    this.spinner.show();
    this.utilityService.pageNotFoundMessage = this.translate.instant("lblPageNotFoundMessage");
    if (this.secureStorageService.getKeyData(localStorageKeys.unauthorizeUser) === true  && this.secureStorageService.getKeyData(localStorageKeys.tinyUrl) == undefined) {
      this.spinner.hide();
      this.router.navigate(['/', 'pagenotfound']);
    } else {
      this.spinner.hide();
      let ngbModalOptions: NgbModalOptions = {
        backdrop : 'static',
        keyboard : false,
        centered: true
  };
      this.logoLink = this.secureStorageService.getKeyData(localStorageKeys.logo);
      let lpModel = this.modalService.open(LpAuthenticationComponent,ngbModalOptions);
      lpModel.componentInstance.callResetAppointment = (name) => {

        lpModel.close();
        this.spinner.show();
        if(isNullOrUndefined(name)){
          this.spinner.hide();
          this.utilityService.pageNotFoundMessage = this.translate.instant("lblPageNotFoundMessage");
          this.router.navigate(['/', 'pagenotfound']);
        }else{
        this.checkInDataService.GetCheckInModuleData().subscribe(results => {
          if (results) {
            this.secureStorageService.setKeyData(localStorageKeys.checkingModule, results);
            this.globalSetting.checkinData.next(results);
            this.removOlderData();
            this.SendWarrantyDocument(true);
            if (results['checkInStatus']) {
              this.spinner.hide();
              this.utilityService.navigateToNext('/' + applicationPaths.seven);
            } else {
                //checkin is not allowed as status is >= car arrived /car is already at dealership
                if(results['isCheckInNotAllowed'])
                {
                  this.spinner.hide();
                  this.secureStorageService.setKeyData(localStorageKeys.isCheckInNotAllowed, 1);
                  this.utilityService.navigateToNext('/' + applicationPaths.seven);
                }
                else
                {
                  this.isCheckInApiCalled.next(true);
                  this.secureStorageService.setKeyData(localStorageKeys.isPlanningAvailable, results['isPlanningAvailable']);
                  this.spinner.hide();
                  this.router.navigateByUrl(this.urlName);
                }
            }
          } else if (results === null) {
            this.spinner.hide();
            this.secureStorageService.removeKey(localStorageKeys.checkingModule);
            this.utilityService.pageNotFoundMessage = this.translate.instant("lblAppointmentNotFound");
            this.router.navigate(['/', 'pagenotfound']);
          }
          else {
            this.spinner.hide();
            this.router.navigateByUrl(this.urlName);
          }
        },
        _error => {
          this.spinner.hide();
          this.utilityService.pageNotFoundMessage = this.translate.instant("lblPageNotFoundMessage");
          this.router.navigate(['/', 'pagenotfound']);
        });
      }
    };
    }
  }

  SendWarrantyDocument(isSend) {
    const checkInData = this.secureStorageService.getKeyData(localStorageKeys.checkingModule);
    if (checkInData) {
    let model = {
      LanguageCode: this.currentLanguageService.currentLanguage.value,
      AppointmentId: 0,
      AppointmentGuid: this.secureStorageService.getKeyData(localStorageKeys.checkingModule).appointmentGuid,
      WorkOrderNo: this.secureStorageService.getKeyData(localStorageKeys.checkingModule).workOrderId,
      DealerId: this.secureStorageService.getKeyData(localStorageKeys.checkingModule)?.dealerDetail?.dealerId,
      IsSend: isSend,
      MakeName: this.secureStorageService.getKeyData(localStorageKeys.checkingModule).vehicleDetail.companyMake
    };
    this.spinner.show();
    this.checkInDataService.SendWarrantyDocument(model).then(
      (res: any) => {
        if (res && res.responseCode == 2) {
          // intentially
          this.globalSetting.warrantyDocumentSigned.next(true);
        }
      }, (_err) => {
        let error = this.translate.instant("lblPdfGenerateError");
        this.toaster.error(error);
      },).finally(() => {
        this.spinner.hide();
      });
    }
  }
}
